/**
 * WormDigSummary — End screen showing dig results.
 */

import type { WormDigResult } from '@/types';

interface WormDigSummaryProps {
  result: WormDigResult;
  onDismiss: () => void;
}

export function WormDigSummary({ result, onDismiss }: WormDigSummaryProps) {
  const allFound = result.wormsFound === result.totalWorms;

  return (
    <div className="absolute inset-0 flex items-center justify-center z-10">
      <div
        className="bg-gray-900/95 border-2 border-amber-500 rounded-2xl p-8 text-center max-w-sm mx-4 shadow-2xl"
        style={{ animation: 'wormSummaryPop 0.3s ease-out' }}
      >
        <div className="text-5xl mb-4">
          {allFound ? '🎉' : '🪱'}
        </div>
        <h2 className="text-2xl font-bold text-amber-300 mb-2">
          {allFound ? 'Nice Digging!' : 'Good Effort!'}
        </h2>
        <p className="text-gray-300 mb-4">
          Found {result.wormsFound} of {result.totalWorms} worm{result.totalWorms !== 1 ? 's' : ''}
        </p>

        {result.baitAwarded > 0 && (
          <div className="bg-amber-900/40 border border-amber-600/50 rounded-lg p-3 mb-4">
            <p className="text-amber-200 font-bold text-lg">
              🪱 +{result.baitAwarded} Worms Added!
            </p>
          </div>
        )}

        <p className="text-xs text-gray-500 mb-4">
          {(result.durationMs / 1000).toFixed(1)}s elapsed
          {result.endedEarly ? ' (ended early)' : ''}
        </p>

        <button
          onClick={onDismiss}
          className="w-full py-3 px-6 bg-amber-600 hover:bg-amber-700 rounded-lg font-bold text-white transition-colors"
        >
          Done
        </button>
      </div>
    </div>
  );
}
